import { render, staticRenderFns } from "./InstagramCarousel.vue?vue&type=template&id=974195ea&scoped=true&"
import script from "./InstagramCarousel.vue?vue&type=script&lang=js&"
export * from "./InstagramCarousel.vue?vue&type=script&lang=js&"
import style0 from "./InstagramCarousel.vue?vue&type=style&index=0&id=974195ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974195ea",
  null
  
)

export default component.exports